import { render, staticRenderFns } from "./Chat-item.vue?vue&type=template&id=345ce821&"
import script from "./Chat-item.vue?vue&type=script&lang=js&"
export * from "./Chat-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports